export default "__VITE_PUBLIC_ASSET__b720a3cf__"